import React from "react";
import { MetypeFeedWidget } from "@metype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";

function MetypeFeedBase({ publisherAttributes = {} }) {
  return (
    <div className="metype-feed">
      <MetypeFeedWidget
        host={publisherAttributes["metypeHost"]}
        accountId={publisherAttributes["metypeAccountId"]}
        primaryColor={publisherAttributes["primaryColor"]}
        className={publisherAttributes["className"]}
        secondaryColor={publisherAttributes["secondaryColor"]}
        publisher={publisherAttributes["publisher"]}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    pageType: get(state, ["qt", "pageType"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const MetypeFeed = connect(
  mapStateToProps,
  null
)(MetypeFeedBase);

MetypeFeedBase.propTypes = {
  publisherAttributes: PropTypes.object
};
